var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { plainToInstance } from 'class-transformer';
import DoctorReportPerDoctor from './DoctorReportPerDoctor';
var DoctorReport = /** @class */ (function (_super) {
    __extends(DoctorReport, _super);
    function DoctorReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DoctorReport.prototype.getTotalPatients = function () {
        return Number(this.total_patients);
    };
    DoctorReport.prototype.getTotalDoctors = function () {
        return Number(this.total_doctors);
    };
    DoctorReport.prototype.getTotalAppointment = function () {
        return Number(this.total_appointments);
    };
    DoctorReport.prototype.getTotalTransactions = function () {
        return this.roundNumber(this.total_transactions);
    };
    DoctorReport.prototype.getAvgTransactions = function () {
        return this.roundNumber(this.avg_transactions);
    };
    DoctorReport.prototype.getAvgConsultationMinutes = function () {
        return Number(this.avg_consultation_minutes) || 0;
    };
    DoctorReport.prototype.getConsultationCompletion = function () {
        return Number(this.consultation_completion) || 0;
    };
    DoctorReport.prototype.getDoctorsReport = function () {
        return plainToInstance(DoctorReportPerDoctor, this.doctors_report);
    };
    return DoctorReport;
}(Model));
export default DoctorReport;
